import { TagEntityType } from "./types";
export const prepareTagRows = (rows, dataTags, investor) => {
    if (!rows || !dataTags || !dataTags.tags) {
        return rows;
    }
    if (investor === TagEntityType.INVESTOR) {
        const newRows = rows.map((row) => {
            const rowEntityId = row.FundId ? `${row.FundId}-${row.Id}` : `${row.Id}-${row.InvestorId}`;
            return {
                ...row,
                tags: dataTags?.tags?.filter((tag) => tag.entityId === rowEntityId)
            };
        });
        return newRows;
    }
    const newRows = rows.map((row) => {
        row.tags = (dataTags?.tags).filter((tag) => tag.entityId === row.Id);
        return row;
    });
    return newRows;
};
export const filterTagLabels = (params) => params.data.tags?.map((tag) => tag.label);
